$(function(){

    // バリエーション画像のラッパー要素
    const $vari_wraps = $('.k_variations');
    
    $vari_wraps.each(function(i, elm){
        // ラッパー内のバリエーション画像を取得
        $varis = $(elm).find('.k_variation');

        // ホバーでバリエーション画像変更
        $varis.each(function(j, val){
            $(val).hover(function(){
                const $displays = $(this).parents('.k_product').find('.k_vari_display');
                $displays.each(function(k, disp){
                    if(j==k-1){
                        $(disp).removeClass("k_variation_hide");
                    }
                    else{
                        $(disp).addClass("k_variation_hide");
                    }
                });
            });
        })
    })
})

console.log('aa');